import Client from "../AxiosClient";
const resource = "/private/files";

export default {
  async get() {
    const response = await Client.get(`${resource}`);
    return response.data;
  },

  async uploadFile(files) {
    try {
        let formData = new FormData();
        formData.append('files', files);
        console.log(formData)
        const result = await Client.post(`${resource}`, formData);
        return result;
    } catch (error) {
        return {error: error};
    }
  },

  update(payload) {},

  delete(id) {},
};
